export default "__VITE_ASSET__BrGbhzoB__"